import { render } from "./EmailVerification.vue?vue&type=template&id=7a173e6a&scoped=true"
import script from "./EmailVerification.vue?vue&type=script&lang=js"
export * from "./EmailVerification.vue?vue&type=script&lang=js"

import "./EmailVerification.vue?vue&type=style&index=0&id=7a173e6a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/eeia-spa/eeia-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a173e6a"]])

export default __exports__